/** search-analytics screen strings (EN source of truth + VI); spread into the main dictionaries */

export const searchAnalyticsEn = {
  'searchAnalytics.title': 'Search analytics',
  'searchAnalytics.subtitle': 'What people search for in this workspace, and which searches come up empty.',
  'searchAnalytics.period.label': 'Period',
  'searchAnalytics.period.7d': '7 days',
  'searchAnalytics.period.30d': '30 days',
  'searchAnalytics.metric.total': 'Total searches',
  'searchAnalytics.metric.ctr': 'Click-through rate',
  'searchAnalytics.metric.zero': 'Zero-result queries',
  'searchAnalytics.top.heading': 'Top queries',
  'searchAnalytics.top.query': 'Query',
  'searchAnalytics.top.count': 'Count',
  'searchAnalytics.top.avgResults': 'Avg. results',
  'searchAnalytics.top.empty': 'No search data yet.',
  'searchAnalytics.gaps.heading': 'Content gaps (zero-result queries)',
  'searchAnalytics.gaps.hint': 'People searched for these terms but found nothing. Consider writing documents for them.',
  'searchAnalytics.gaps.count': 'Searched {count} times',
  'searchAnalytics.types.heading': 'Search type distribution',
  'searchAnalytics.types.hybrid': 'Hybrid',
  'searchAnalytics.types.keyword': 'Keyword',
  'searchAnalytics.types.semantic': 'Semantic',
  'searchAnalytics.adminRequired': 'Admin access required',
  'searchAnalytics.adminRequiredHint': 'Only workspace admins can view search analytics.',
  'searchAnalytics.error': 'Failed to load search analytics.',
} satisfies Record<string, string>

export const searchAnalyticsVi: Record<keyof typeof searchAnalyticsEn, string> = {
  'searchAnalytics.title': 'Phân tích tìm kiếm',
  'searchAnalytics.subtitle': 'Mọi người tìm gì trong workspace này, và những lượt tìm kiếm nào không có kết quả.',
  'searchAnalytics.period.label': 'Khoảng thời gian',
  'searchAnalytics.period.7d': '7 ngày',
  'searchAnalytics.period.30d': '30 ngày',
  'searchAnalytics.metric.total': 'Tổng lượt tìm kiếm',
  'searchAnalytics.metric.ctr': 'Tỷ lệ nhấp',
  'searchAnalytics.metric.zero': 'Truy vấn không có kết quả',
  'searchAnalytics.top.heading': 'Truy vấn hàng đầu',
  'searchAnalytics.top.query': 'Truy vấn',
  'searchAnalytics.top.count': 'Số lượt',
  'searchAnalytics.top.avgResults': 'Kết quả TB',
  'searchAnalytics.top.empty': 'Chưa có dữ liệu tìm kiếm.',
  'searchAnalytics.gaps.heading': 'Nội dung còn thiếu (truy vấn không có kết quả)',
  'searchAnalytics.gaps.hint': 'Mọi người đã tìm các từ khóa này nhưng không thấy gì. Hãy cân nhắc viết tài liệu cho chúng.',
  'searchAnalytics.gaps.count': 'Đã tìm {count} lần',
  'searchAnalytics.types.heading': 'Phân bố loại tìm kiếm',
  'searchAnalytics.types.hybrid': 'Kết hợp',
  'searchAnalytics.types.keyword': 'Từ khóa',
  'searchAnalytics.types.semantic': 'Ngữ nghĩa',
  'searchAnalytics.adminRequired': 'Cần quyền quản trị',
  'searchAnalytics.adminRequiredHint': 'Chỉ quản trị viên workspace mới xem được phân tích tìm kiếm.',
  'searchAnalytics.error': 'Không tải được dữ liệu phân tích tìm kiếm.',
}
